<template lang="html">
<div class="sl-qrcode" v-loading="fullLoading">
  <row>
    <div class="sl-col-4">
      <div class="sl-form">
        <h3>{{$t('Views.QrCode.title')}}</h3>
        <div class="sl-merchant-qrcode">
          <div class="sl-qrimg" v-for="item in qrcodeData">
            <img :src="item" alt="">
            <sl-a class="sl-el-btn el-button" :href="item" @click.native="$ga.event('Button', 'Download', 'QrCode')" :text="$t('Views.QrCode.download')"></sl-a>
          </div>
        </div>

        <div class="sl-store-qrcode">
          <h3>{{$t('Views.QrCode.storeTitle')}}</h3>
          <div class="sl-store-qrcode-checkbox">
            <el-checkbox-group v-model="checkedBoxes" @change="handleCheckedCitiesChange" class="sl-checkbox-group">
              <el-checkbox v-for="item in stores" :label="item.storeId" :key="item.storeId">
                <span>{{item.storeName}}</span>
                <el-tooltip placement="bottom" effect="light">
                  <img slot="content" :src="item.qrcodeUrl" alt="" class="sl-hover-qrcode">
                  <img src="../../assets/imgs/qrcode_active.png" alt="" class="sl-mini-qrcode">
                </el-tooltip>
              </el-checkbox>
            </el-checkbox-group>
            <el-checkbox class="sl-select-all" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">Select all</el-checkbox>
            <!-- <a class="sl-el-btn el-button" @click="checkDownload">{{$t('Views.QrCode.download')}}</a> -->
            <sl-btn :text="$t('Functional.download')" icon="sl-download" @click.native="checkDownload"></sl-btn>
          </div>

        </div>
      </div>
    </div>

  </row>
</div>
</template>

<script>
import api from '../../api'
import download from '../../util/download'
export default {
  name: 'QRcode',
  data() {
    return {
      qrcodeData: [],
      checkAll: false,
      checkedBoxes: [],
      stores: [],
      isIndeterminate: false,
      fullLoading: false
    }
  },
  created() {
    const vm = this
    this.fullLoading = true
    api.FetchQrCode().then(res => {
      if (res.data.code === 200) {
        const result = res.data.data
        vm.qrcodeData = [result.merchant.qrcodeUrl, result.merchant.tableQrcodeUrl]
        vm.stores = result.storeList
      }
      vm.fullLoading = false
    })
  },
  methods: {
    handleCheckAllChange(event) {
      this.checkedBoxes = event.target.checked ? this.stores.map(item => item.storeId) : []
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.stores.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.stores.length
    },
    beforeDownload() {
      return this.checkedBoxes.length === 0 ? !true : true
    },
    checkDownload() {
      this.$ga.event('Button', 'Download', 'QR code')
      if (!this.beforeDownload()) {
        this.$message.error('Please select at least one store.')
        return false
      }
      const vm = this
      this.fullLoading = true
      api.CheckDownloadQrcodeZip({
        storeId: this.checkedBoxes.join(','),
        style: this.$store.state.theme.name === 'default' ? '01' : this.$store.state.theme.name.concat('_01')
      }).then(function (res) {
        if (typeof res.data.code === 'number' && res.data.code !== 200) {
          vm.$message.error(res.data.msg)
          vm.fullLoading = false
        } else {
          vm.download()
        }
      })
    },
    download() {
      const vm = this
      api.DownloadQrcodeZip({
        storeId: this.checkedBoxes.join(','),
        style: this.$store.state.theme.name === 'default' ? '01' : this.$store.state.theme.name.concat('_01')
      }).then(function (response) {
        const data = new Blob([response.data], {
          type: response.headers['content-type']
        })
        download(data, response.headers['content-disposition'].replace(/"/g, '').split('filename=')[1])
        vm.fullLoading = false
      })
    }
  }
}
</script>
<style scoped>
.sl-store-qrcode {
  border-top: 1px solid #d8d8d8;
  margin-top: 60px;
}

.sl-form h3 {
  padding-bottom: 20px;
  height: 50px;
  color: #4A4A4A;
  font-weight: normal;
  margin-top: 30px;
}

.sl-qrimg {
  display: inline-block;
  width: 100%;
  max-width: 250px;
  text-align: center;
}

.sl-qrimg img {
  height: 250px;
}

.sl-qrimg a {
  margin-top: 30px;
  display: inline-block;
}

.sl-download {
  display: inline-block;
  font-size: 14px;
  color: #4A4A4A;
  padding: 10px 25px;
  background: #FFFFFF;
  border: 1px solid #CCCCCC;
  border-radius: 2px;
  margin-top: 30px;
  cursor: pointer;
}

@media only screen and (max-width: 768px) {
  .sl-qrimg {
    margin-bottom: 40px;
  }
}

.sl-mini-qrcode {
  width: 20px;
  height: 20px;
  position: relative;
  right: -15px;
}

.sl-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
</style>

<style>
.sl-qrcode .el-checkbox+.el-checkbox {
  margin-left: 0;
}

.sl-qrcode .el-checkbox__label {
  font-size: 14px;
  color: #4A4A4A;
  line-height: 20px;
  padding-left: 24px;
  width: 200px;
  display: inline-block;
  font-weight: normal;
  line-height: 1;
}

.sl-qrcode .sl-select-all .el-checkbox__label {
  width: 150px;
}

.sl-qrcode .sl-select-all .el-checkbox__label span {
  width: 120px;
}

.sl-qrcode .el-checkbox__label span {
  width: 130px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 14px;
  vertical-align: middle;
}

.sl-qrcode .el-checkbox__label img {
  display: none;
}

.sl-qrcode .el-checkbox:hover img {
  display: inline-block;
}

.sl-qrcode .el-checkbox:hover {
  background: #F3F3F3;
}

.sl-qrcode .el-checkbox:hover span {
  color: #2B90E9;
}

.sl-qrcode .el-checkbox {
  padding: 10px 10px 7px 10px;
}

.sl-store-qrcode-checkbox,
.sl-merchant-qrcode {
  padding: 0 30px;
}

.sl-hover-qrcode {
  width: 130px;
  height: 130px;
}
</style>



// WEBPACK FOOTER //
// qrcodes.vue?1368ba8d